import React , {useState} from 'react';
import ModelFormItem from "./model-form-item";
import {Redirect} from 'react-router-dom';

const ContactModel = () => {

    async function sendMessage(name, Message ,email, phone , company ){

        try{
            const res = await fetch('http://143.198.24.1:3000/api/form/create', {
            method: 'POST',
            headers: {'Content-Type':'application/json' ,  'Authorization': 'Bearer ' + localStorage["token"]  },
            body:JSON.stringify( { "name":name , "Message": Message , "email": email , "phone": phone , "company":company } )
        });
            const usermessage = await res.json();
            console.log(usermessage);
            setDone(true);
            
        } catch(err){
            console.error(err);
            setWrong(true);
        }
    }

    const [state, setState] =useState({
        "name": undefined,
        "Message":undefined,
        "email":undefined,
        "phone":undefined,
        "company":undefined
    });

    const [wrong, setWrong] =useState(false);
    const [done , setDone] = useState(false);
    
    const handleChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;
      setState(state => ( {...state, [name] : value} ));
    }

    const handleSend = () => {
        sendMessage(state.name, state.Message , state.email, state.phone, state.company   );
        
        if (done)
        { 
            return(
                <Redirect to={"/home"} />
            );  
        }

      }

    return(
        <div className="modal fade contact-model" id="contactModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="close-model" data-dismiss="modal">X</div>
                            <div className="title-content">
                                <h3 className="model-title">تواصل معنا</h3>
                                <p className="model-subtitle">ابقى على إطلاع بآخر المقالات و العروض التى نقدمها</p>
                            </div>
                            <form >
                                <ModelFormItem inputName={"الاسم"} inputType={"text"} name="name" value={state.name} onChange={handleChange}/>
                                <ModelFormItem inputName={"رقم الجوال"} inputType={"tel"} name="phone" value={state.phone} onChange={handleChange}/>
                                <ModelFormItem inputName={"اسم الشركة"} inputType={"text"} name="company" value={state.company} onChange={handleChange}/>
                                <ModelFormItem inputName={"البريد الإلكترونى"} inputType={"email"} name="email" value={state.email} onChange={handleChange}/>
                            <div className="form-group cassandra-form-group">
                                <label>رسالتك </label>
                                <textarea className="form-control cassandra-form-control" rows="4" name="message" value={state.Message} onChange={handleChange}  placeholder="اكتب رسالتك أو استفسارك هنا"/>
                            </div>

                                <div className="text-center">
                            <button className="submit-btn" type="button" onClick={handleSend} > إرسال </button>
                                    {
                                        wrong && 
                                        <div className="wrong-data" >هناك شئ خاطئ من فضلك أعد الإرسال</div>
                                    }
                                </div>
                            </form>
                    </div>
                </div>
            </div>
         </div>
    );

};
export default ContactModel;
